import React from 'react';
import { Box } from '@saviynt/design-system';
import cx from 'classnames';

import TCodeItem from '../../shared/components/AuditLogViewer/TCodeItem';
import ViewMoreButton from '../../shared/components/AuditLogViewer/ViewMoreButton';
import useTCodeList from '../../shared/hooks/use-tcodelist';
import { type TCodeListProps } from '../../shared/types';

import './TCodeListRow.css';

/**
 * TCodeListRow Component
 * Displays a list of T-codes with descriptions, hover interactions, and expandable rows.
 * Initially shows only 5 items with a "View more" button if there are more items.
 * When hovering over a T-code, additional details are shown in a tooltip.
 * Clicking the chevron down arrow expands the row to show all details.
 */
function TCodeListRow({
  tCodes,
  className,
  onCodeClick,
}: TCodeListProps): React.ReactElement {
  const {
    showAll,
    sortedTCodes,
    paginatedData,
    hasMoreItems,
    remainingCount,
    handleViewMore,
    handleCodeClick,
  } = useTCodeList({ tCodes, onCodeClick });

  const itemsToShow = showAll ? sortedTCodes : paginatedData.data;

  return (
    <Box className={cx('Sod-TCodeListRow', className)}>
      <Box className='Sod-TCodeListRow-container'>
        {itemsToShow.map((tCode) => (
          <TCodeItem key={tCode.id} tCode={tCode} onClick={handleCodeClick} />
        ))}
      </Box>

      {hasMoreItems && !showAll && (
        <ViewMoreButton
          remainingCount={remainingCount}
          onClick={handleViewMore}
        />
      )}
    </Box>
  );
}

TCodeListRow.defaultProps = {
  className: undefined,
  onCodeClick: undefined,
};

export default TCodeListRow;
